/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { CheckInRawBoardingPassRequestItem } from '../../models/check-in-raw-boarding-pass-request-item';
import { CheckInRawBoardingPassResponseItem } from '../../models/check-in-raw-boarding-pass-response-item';

export interface GetRawBoardingPass$Params {
  orderId: string;
  hash: string;
      body: Array<CheckInRawBoardingPassRequestItem>
}

export function getRawBoardingPass(http: HttpClient, rootUrl: string, params: GetRawBoardingPass$Params, context?: HttpContext): Observable<DapiHttpResponse<Array<CheckInRawBoardingPassResponseItem>>> {
  const rb = new DapiRequestBuilder(rootUrl, getRawBoardingPass.PATH, 'post');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.query('hash', params.hash, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<Array<CheckInRawBoardingPassResponseItem>>;
    }),
    catchErrorAsJson()
  );
}

getRawBoardingPass.PATH = '/api/v2/checkin/{orderId}/raw-boarding-pass';
